import React from 'react'

const Eventsaboutsubscription = () => {
  return (
    <div>

    </div>
  )
}

export default Eventsaboutsubscription
